module.exports = __webpack_public_path__ + "img/34-whjszyxy.6ff5636b.png";